import Gator from 'gator';

function closeAllAustriaBoxes(openArea) {
    let boxes = document.querySelectorAll('.consultation-austria .area');

    for (let i = 0; i < boxes.length; i++) {
        if (openArea && boxes[i].classList.contains(openArea)) {
            boxes[i].classList.add('-open');
        } else {
            boxes[i].classList.remove('-open');
        }
    }
}

function closeAllInternationalBoxes() {
    let boxes = document.querySelectorAll(
        '.consultation-international .area-box'
    );

    for (let i = 0; i < boxes.length; i++) {
        boxes[i].classList.remove('-open');
    }
}

Gator(_gg.html).on('click', '.consultation-austria_map', function (event) {
    event.preventDefault();
    closeAllAustriaBoxes();
    this.blur();
});

Gator(_gg.html).on('click', '.consultation-austria .area-trigger', function (
    event
) {
    event.preventDefault();
    closeAllAustriaBoxes();
    this.parentNode.parentNode.parentNode.parentNode.classList.add('-open');
    this.blur();
});

Gator(_gg.html).on(
    'click',
    '.consultation-international .area-trigger',
    function (event) {
        event.preventDefault();
        closeAllInternationalBoxes();
        this.parentNode.parentNode.parentNode.parentNode.classList.add('-open');
        this.blur();
    }
);

Gator(_gg.html).on('click', '.area-close', function (event) {
    event.preventDefault();
    this.parentNode.parentNode.parentNode.classList.remove('-open');
    this.blur();
});

Gator(_gg.html).on('click', '.consultation-austria_map [data-area]', function (
    event
) {
    event.preventDefault();
    let area = this.getAttribute('data-area');
    if (area) {
        closeAllAustriaBoxes(area);
    }
});
